// Auth
export const POST_JWT_LOGIN = "/auth/local";
export const POST_FORGET_PASSWORD = "/auth/forgot-password";
export const POST_CHANGE_PASSWORD = "/auth/change-password";
export const POST_RESET_PASSWORD = "/auth/reset-password";
export const POST_REGISTER = "/auth/local/register";
export const POST_REACTIVATE_ACCOUNT = "/user-management/reactivate-account";
export const APPROVE_USER = "/user-management/users/approve";

export const SOCIAL_LOGIN = "/social-login";

// Countries
export const GET_COUNTRIES = "/countries";
export const GET_GLOBAL_COUNTRIES = "/global/countries";

// Agencies
export const GET_GLOBAL_AGENCIES = "/global-admin/agencies";
export const GET_AGENCIES = "/agencies";
export const ADD_AGENCY = "/agencies";
export const UPDATE_AGENCY = "/agencies";
export const DELETE_AGENCY = "/agencies";

// Role
export const GET_ROLES = "/users-permissions/roles";
export const GET_ROLE = "/users-permissions/roles";

// Users
export const GET_USERS_DEFAULT = "/users";
export const GET_USERS = "/user-management/users";
export const GET_USER = "/user-management/users";
export const ADD_USER = "/user-management/users";
export const EXPORT_USERS_TO_CSV = "/user-management/users/export/csv";
export const UPDATE_USER = "/user-management/users";
export const DELETE_USER = "/user-management/users";
export const ACTIVATE_USER = "/user-management/users/activate";
export const DEACTIVATE_USER = "/user-management/users/deactivate";
export const GET_USER_PROFILE = "/users/me";
export const UPDATE_MY_PROFILE = "/user-management/users/me";

export const GET_AGENCY_USERS = "/agency/user-management/users";
export const INVITE_USER = "/user-management/users/invite";
export const ACTIVATE_AGENCY_USER = "/agency/user-management/users/activate";
export const DEACTIVATE_AGENCY_USER =
  "/agency/user-management/users/deactivate";
export const VERIFY_NEW_SIGNUP = "/user-management/verify-new-signup";
//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";

// Sanctions List
export const GET_EU_SANCTIONS_LIST = "/eu-sanctions-lists";
export const GET_EU_SANCTIONED_ITEM = "/eu-sanctions-lists";
export const GET_EU_SANCIONS_LIST_PROGRAMMES =
  "/eu-sanctions-list/list/get-programmes";
export const GET_US_SANCTIONS_LIST = "/us-sanctions-lists";
export const GET_US_SANCTIONED_ITEM = "/us-sanctions-lists";
export const GET_US_SANCTIONS_LIST_PROGRAM =
  "/us-sanctions-list/list/get-programs";
export const GET_UK_SANCTIONS_LIST = "/uk-sanctions-lists";
export const GET_UK_SANCTIONED_ITEM = "/uk-sanctions-lists";
export const GET_UK_SANCTIONS_LIST_REGIMES =
  "/uk-sanctions-list/list/get-regimes";
export const GET_UNGM_LIST = "/ungm-lists";
export const GET_UNGM_ITEM = "/ungm-lists";
export const GET_UNGM_LIST_COUNTRIES = "/ungm-lists/list/get-countries";
export const GET_UN_DESIGNATED_LIST = "/un-designated-lists";
export const GET_UN_DESIGNATED_ITEM = "/un-designated-lists";
export const GET_UN_DESIGNATED_LIST_TYPES =
  "/un-designated-list/list/get-un-list-types";
export const UPLOAD_UNGM_LIST = "/ungm-lists/upload-content";
export const GET_WB_BANNED_LIST = "/world-bank-banned-lists";
export const GET_WB_BANNED_ITEM = "/world-bank-banned-lists";
export const GET_WB_BANNED_LIST_COUNTRIES =
  "/world-bank-banned-lists/list/get-countries";

// Contracts
export const GET_CONTRACTS = "/contracts";
export const GET_CONTRACT = "/contracts";
export const ADD_CONTRACT = "/contracts";
export const UPDATE_CONTRACT = "/contracts";
export const DELETE_CONTRACT = "/contracts";
export const IMPORT_CONTRACT = "/contracts/import";
export const EXPORT_CONTRACTS_TO_CSV = "/contracts/export/csv";

// LTAs
export const ADD_LTA = "/lta";
export const GET_LTA = "/lta";
export const UPDATE_LTA = "/lta";
export const DELETE_LTA = "/lta";
export const IMPORT_LTA = "/lta/import";
export const EXPORT_LTAS_TO_CSV = "/lta/export/csv";

// Agency LTAs
export const GET_AGENCY_LTAS = "/agency/lta";
export const GET_AGENCY_LTA = "/agency/lta";
export const ADD_AGENCY_LTA = "/agency/lta";
export const UPDATE_AGENCY_LTA = "/agency/lta";
export const DELETE_AGENCY_LTA = "/agency/lta";

export const GET_CONTRACT_DISTRIBUTION_BY_TYPE =
  "/contracts/stats/distribution-by-type";
export const GET_CONTRACTS_SUMMARY = "/contracts/stats/summary";
export const GET_LTA_SUMMARY = "/contracts/stats/lta-summary";
export const GET_CONTRACT_DISTRIBUTION_BY_AGENCY =
  "/contracts/stats/distribution-by-agency";
export const GET_CONTRACT_TOTALS = "/contracts/stats/totals";
export const GET_CONTRACT_DISTRIBUTION_BY_REGION =
  "/contracts/stats/distribution-by-region";
export const GET_CONTRACT_DISTRIBUTION_BY_REGION_TYPE =
  "/contracts/stats/distribution-by-region-type";

export const GET_AGENCY_CONTRACTS = "/agency/contracts";
export const GET_AGENCY_CONTRACT = "/agency/contracts";
export const ADD_AGENCY_CONTRACT = "/agency/contracts";
export const UPDATE_AGENCY_CONTRACT = "/agency/contracts";
export const DELETE_AGENCY_CONTRACT = "/agency/contracts";
export const GET_AGENCY_ACTIVE_CONTRACT_VALUE =
  "/agency/contracts/active-contract-value";
export const GET_AGENCY_CONTRACT_DISTRIBUTION_BY_TYPE =
  "/contracts/distribution-by-type";

// Contractors
export const GET_CONTRACTORS = "/contractors";
export const GET_CONTRACTOR = "/contractors";
export const ADD_CONTRACTOR = "/contractors";
export const UPDATE_CONTRACTOR = "/contractors";
export const DELETE_CONTRACTOR = "/contractors";
export const IMPORT_CONTRACTOR = "/contractors/import";
export const EXPORT_CONTRACTORS_TO_CSV = "/contractors/export/csv";
export const MERGE_CONTRACTORS = "/contractors";

// Contractor Duplicates
export const SCAN_CONTRACTOR_DUPLICATES = "/contractor-duplicates/scan";
export const GET_CONTRACTOR_DUPLICATES = "/contractor-duplicates";
export const RESOLVE_CONTRACTOR_DUPLICATE = "/contractor-duplicates";

export const GET_AGENCY_CONTRACTORS = "/agency/contractors";
export const GET_AGENCY_CONTRACTOR = "/agency/contractors";
export const ADD_AGENCY_CONTRACTOR = "/agency/contractors";
export const UPDATE_AGENCY_CONTRACTOR = "/agency/contractors";
export const DELETE_AGENCY_CONTRACTOR = "/agency/contractors";

export const GET_PERFORMANCE_RATINGS = "/performance-ratings";
export const GET_PERFORMANCE_RATING = "/performance-ratings";
export const IMPORT_PERFORMANCE_RATING = "/performance-ratings/import";
export const ADD_PERFORMANCE_RATING = "/performance-ratings";
export const UPDATE_PERFORMANCE_RATING = "/performance-ratings";
export const DELETE_PERFORMANCE_RATING = "/performance-ratings";
export const EXPORT_PERFORMANCE_RATINGS_TO_CSV =
  "/performance-ratings/export/csv";

export const GET_PERFORMANCE_RATING_TYPES = "/performance-rating-types";
export const GET_PERFORMANCE_RATING_TYPE = "/performance-rating-types";
export const ADD_PERFORMANCE_RATING_TYPE = "/performance-rating-types";
export const UPDATE_PERFORMANCE_RATING_TYPE = "/performance-rating-types";
export const DELETE_PERFORMANCE_RATING_TYPE = "/performance-rating-types";

export const GET_CONTRACTOR_SUMMARY = "/contractors/summary";

export const UPDATE_CONTRACTOR_SEMG_MENTION = "/contractors";
export const UPDATE_CONTRACTOR_PERFORMANCE_RATING = "/contractors";
export const UPDATE_CONTRACTOR_BOARD_OF_DIRECTORS = "/contractors";
export const UPDATE_CONTRACTOR_AFFILIATIONS_TO_PERSON = "/contractors";
export const UPDATE_CONTRACTOR_AFFILIATIONS_TO_CONTRACTOR = "/contractors";

// Contract Ratings
export const GET_CONTRACT_RATINGS = "/contract-ratings";
export const GET_CONTRACT_RATING = "/contract-ratings";
export const ADD_CONTRACT_RATING = "/contract-ratings";
export const UPDATE_CONTRACT_RATING = "/contract-ratings";
export const DELETE_CONTRACT_RATING = "/contract-ratings";

// Contract Types
export const GET_CONTRACT_TYPES = "/contract-types";
export const GET_CONTRACT_TYPE = "/contract-types";
export const ADD_CONTRACT_TYPE = "/contract-types";
export const UPDATE_CONTRACT_TYPE = "/contract-types";
export const DELETE_CONTRACT_TYPE = "/contract-types";

// Risk Assessments
export const GET_RISK_ASSESSMENTS = "/risk-assessments";
export const GET_RISK_ASSESSMENT = "/risk-assessments";
export const ADD_RISK_ASSESSMENT = "/risk-assessments";
export const UPDATE_RISK_ASSESSMENT = "/risk-assessments";
export const DELETE_RISK_ASSESSMENT = "/risk-assessments";
export const GET_RESTRICTED_FILES = "/risk-assessments";
export const GET_CONFIDENTIAL_FILES = "/risk-assessments";
export const IMPORT_RISK_ASSESSMENTS = "/risk-assessments/import";
export const EXPORT_RISK_ASSESSMENTS_TO_CSV = "/risk-assessments/export/csv";

// Assessments
export const GET_ASSESSMENTS = "/assessments";
export const GET_ASSESSMENT = "/assessments";
export const ADD_ASSESSMENT = "/assessments";
export const UPDATE_ASSESSMENT = "/assessments";
export const DELETE_ASSESSMENT = "/assessments";
export const IMPORT_ASSESSMENTS = "/assessments/import";

// Capacity Assessments
export const GET_CAPACITY_ASSESSMENTS = "/capacity-assessments";
export const GET_CAPACITY_ASSESSMENT = "/capacity-assessments";
export const ADD_CAPACITY_ASSESSMENT = "/capacity-assessments";
export const UPDATE_CAPACITY_ASSESSEMENT = "/capacity-assessments";
export const DELETE_CAPACITY_ASSESSMENT = "/capacity-assessments";
export const IMPORT_CAPACITY_ASSESSMENTS = "/capacity-assessments/import";
export const EXPORT_CAPACITY_ASSESSMENTS_TO_CSV =
  "/capacity-assessments/export/csv";

export const GET_AGENCY_CAPACITY_ASSESSMENTS = "/agency/capacity-assessments";
export const GET_AGENCY_CAPACITY_ASSESSMENT = "/agency/capacity-assessments";
export const ADD_AGENCY_CAPACITY_ASSESSMENT = "/agency/capacity-assessments";
export const UPDATE_AGENCY_CAPACITY_ASSESSEMENT =
  "/agency/capacity-assessments";
export const DELETE_AGENCY_CAPACITY_ASSESSMENT = "/agency/capacity-assessments";

// Capacity Assessment Types
export const GET_CAPACITY_ASSESSMENT_TYPE = "/capacity-assessment-types";
export const GET_CAPACITY_ASSESSMENT_TYPES = "/capacity-assessment-types";
export const ADD_CAPACITY_ASSESSMENT_TYPE = "/capacity-assessment-types";
export const UPDATE_CAPACITY_ASSESSMENT_TYPE = "/capacity-assessment-types";
export const DELETE_CAPACITY_ASSESSMENT_TYPE = "/capacity-assessment-types";

// Assessment Types
export const GET_ASSESSMENT_TYPE = "/assessment-types";
export const GET_ASSESSMENT_TYPES = "/assessment-types";
export const ADD_ASSESSMENT_TYPE = "/assessment-types";
export const UPDATE_ASSESSMENT_TYPE = "/assessment-types";
export const DELETE_ASSESSMENT_TYPE = "/assessment-types";

// Capacity Assessment Ratings
export const GET_CAPACITY_ASSESSMENT_RATINGS = "/capacity-assessment-ratings";
export const GET_CAPACITY_ASSESSMENT_RATING = "/capacity-assessment-ratings";
export const ADD_CAPACITY_ASSESSMENT_RATING = "/capacity-assessment-ratings";
export const UPDATE_CAPACITY_ASSESSMENT_RATING = "/capacity-assessment-ratings";
export const DELETE_CAPACITY_ASSESSMENT_RATING = "/capacity-assessment-ratings";

// Risk Ratings
export const GET_RISK_RATINGS = "/risk-assessment-ratings";
export const GET_RISK_RATING = "/risk-assessment-ratings";
export const ADD_RISK_RATING = "/risk-assessment-ratings";
export const UPDATE_RISK_RATING = "/risk-assessment-ratings";
export const DELETE_RISK_RATING = "/risk-assessment-ratings";

// PVRs
export const GET_PVRS = "/partner-verification-reports";
export const GET_PVR = "/partner-verification-reports";
export const ADD_PVR = "/partner-verification-reports";
export const UPDATE_PVR = "/partner-verification-reports";
export const DELETE_PVR = "/partner-verification-reports";
export const IMPORT_PVRS = "/partner-verification-reports/import";
export const EXPORT_PVRS_TO_CSV = "/partner-verification-reports/export/csv";

export const GET_AGENCY_PVRS = "/agency/partner-verification-reports";
export const GET_AGENCY_PVR = "/agency/partner-verification-reports";
export const ADD_AGENCY_PVR = "/agency/partner-verification-reports";
export const UPDATE_AGENCY_PVR = "/agency/partner-verification-reports";
export const DELETE_AGENCY_PVR = "/agency/partner-verification-reports";

// Organization Types
export const GET_ORGANIZATION_TYPES = "/organization-types";
export const GET_ORGANIZATION_TYPE = "/organization-types";
export const ADD_ORGANIZATION_TYPE = "/organization-types";
export const UPDATE_ORGANIZATION_TYPE = "/organization-types";
export const DELETE_ORGANIZATION_TYPE = "/organization-types";

// Search
export const DOWNLOAD_SEARCH_REPORT = "/search/report";
export const DOWNLOAD_BULK_SEARCH_TEMPLATE = "/search/bulk-search-template";
export const BULK_SEARCH = "/search/bulk-search";
export const BULK_SEARCH_PROGRESS = "/search/bulk-search/status";
export const SEARCH_GLOBAL_CONTENT = "/search";

// Persons
export const GET_PERSONS = "/persons";
export const GET_PERSON = "/persons";
export const ADD_PERSON = "/persons";
export const UPDATE_PERSON = "/persons";
export const DELETE_PERSON = "/persons";
export const IMPORT_PERSON = "/persons/import";
export const EXPORT_PERSONS_TO_CSV = "/persons/export/csv";
export const UPDATE_PERSON_SEMG_MENTION = "/persons";
export const UPDATE_PERSON_AFFILIATIONS_TO_CONTRACTOR = "/persons";
export const UPDATE_PERSON_AFFILIATIONS_TO_PERSON = "/persons";

// SEMG Mentions
export const GET_SEMG_MENTIONS = "/semg-mentions";
export const GET_SEMG_MENTION = "/semg-mentions";
export const ADD_SEMG_MENTION = "/semg-mentions";
export const UPDATE_SEMG_MENTION = "/semg-mentions";
export const DELETE_SEMG_MENTION = "/semg-mentions";

// Regions
export const GET_REGIONS = "/regions";
export const GET_REGION = "/regions";
export const ADD_REGION = "/regions";
export const UPDATE_REGION = "/regions";
export const DELETE_REGION = "/regions";

// Analytics
export const POST_USER_ACTIVITY = "/user-activities";
export const GET_USER_ACTIVITIES = "/user-activities";
export const DELETE_USER_ACTIVITY = "/user-activities";
export const GET_PAGE_TYPES = "/frontend-pages";
export const GET_USER_ACTIVITY_TREND = "/user-activities/trend";
export const GET_USER_ACTIVITY_STATS = "/user-activities/stats";
export const GET_TOP_PAGES = "/user-activities/stats/top-pages";
export const GET_DD_SEARCHES = "/search-reports";
export const GET_MOST_VIEWED_CONTENT =
  "/user-activities/stats/most-viewed-content";

// Settings
export const GET_SETTINGS = "/settings";
export const UPDATE_SETTING = "/settings";

// Classified Information
export const GET_CLASSIFIED_INFORMATION_TYPES = "/classified-information-types";
export const GET_CLASSIFIED_INFORMATION_TYPE = "/classified-information-types";

export const GET_CLASSIFIED_INFORMATION = "/classified-information";
export const UPDATE_CLASSIFIED_INFORMATION = "/persons";
